import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-semantics-donut-intent',
  templateUrl: './semantics-donut-intent.component.html',
  styleUrl: './semantics-donut-intent.component.scss',
})
export class SemanticsDonutIntentComponent {
  isLoading = true;

  options: echarts.EChartsOption = {
    legend: {
      orient: 'vertical',
      left: 'right',
      top: 'middle',
      type: 'scroll',
      height: 350, // or a percentage like '70%'
    },
    series: {
      center: ['44%', '50%'],
    },
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsDonutIntent$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsDonutIntent');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsDonutIntent().subscribe();
  }

  get series() {
    return this.analyticsService.semanticsDonutIntent$.value?.series[0];
  }

  get labels() {
    return this.analyticsService.semanticsDonutIntent$.value?.labels;
  }
}
